import React, { useState, useEffect } from "react";
import axios from "axios";

import Header_titleEn from "../controls/Header_titleEn";
import Footer_last from "../controls/Footer_last";

import {
  Layout,
  Row,
  Col,
  Space,
  Divider,
  PageHeader,
  List,
  Tooltip,
  Typography
} from "antd";

import { createGlobalStyle } from "styled-components";

import ThIcon from "../pics/th_icon.png";
import EnIcon from "../pics/en_icon.png";
import AddImg from "../pics/add-image.png";
import EditImg from "../pics/edit-image.png";
import Logo from "../pics/RIHES-Logo1.png";

import "./index.css";

import ResearchCard from "../controls/ResearchCardEn";

const { Content } = Layout;

const StyledForm = createGlobalStyle`.ant-form-item {
    margin-bottom: 5px;
  }
  `;

const Research_rihes_list_en = () => {
  let xURL = "";
  let xlocation = window.location.hostname;

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const [xTitle, _xTitle] = useState();
  const [xLng, _xLng] = useState();

  const [dataSource, _dataSource] = useState();
  const [dataSource2, _dataSource2] = useState();

  const [dataSource3, _dataSource3] = useState();
  const [dataSource4, _dataSource4] = useState();

  const [dataSource5, _dataSource5] = useState();
  const [dataSource6, _dataSource6] = useState();
  const [dataSource7, _dataSource7] = useState();
  const [dataSource8, _dataSource8] = useState();

  const [dataSource9, _dataSource9] = useState();
  const [dataSource10, _dataSource10] = useState();

  useEffect(() => {
    var url = new URL(window.location.href);

    // if (url.searchParams.get("pages") == "IDSU") {
    //   _xTitle(
    //     "Research Center for Infectious Diseases and Substance Use (IDSU)"
    //   );
    //   _xLng("IDSU");

    //   Getdata("IDSU");
    // } else if (url.searchParams.get("pages") == "CMBI") {
    //   _xTitle("Research Center for Molecular and Cell Biology (CMBI)");
    //   _xLng("CMBI");

    //   Getdata("CMBI");
    // } else if (url.searchParams.get("pages") == "NINE") {
    //   _xTitle(
    //     "Research Center for Non-Infectious Diseases and Environmental Health Sciences (NINE)"
    //   );
    //   _xLng("NINE");

    //   Getdata("NINE");
    // } else

    if (url.searchParams.get("pages") == "SHSR") {
      _xTitle("School of Health Sciences Research (SHSR)");
      _xLng("SHSR");

      Getdata("SHSR");
    } else if (url.searchParams.get("pages") == "HSRC") {
      _xTitle("Health Sciences Research Center (HSRC)");
      _xLng("HSRC");

      Getdata("HSRC");
    } else if (url.searchParams.get("pages") == "PROCRC") {
      _xTitle("RIHES-Pro CRC (PROCRC)");
      _xLng("PROCRC");

      Getdata("PROCRC");
    }
  }, []);

  const Getdata = zdata => {
    let xcenter = "";

    // if (zdata == "IDSU") {
    //   xcenter = "1";
    // } else if (zdata == "CMBI") {
    //   xcenter = "2";
    // } else if (zdata == "NINE") {
    //   xcenter = "3";
    // } else

    if (zdata == "SHSR") {
      xcenter = "4";
    } else if (zdata == "HSRC") {
      xcenter = "2";
    } else if (zdata == "PROCRC") {
      xcenter = "1";
    }

    axios
      .post(xURL + "getResearch_rihesEn", {
        center: xcenter,
        order: 1
      })
      .then(result => {
        const Tb1 = [];

        let xresearcher_expertise = "",
          xpositionex = "";

        result.data.forEach((i, idx) => {
          if (!i.researcher_expertise) {
            xresearcher_expertise = ["-"];
          } else {
            if (i.researcher_expertise.split("|").length > 0) {
              xresearcher_expertise = i.researcher_expertise.split("|");
            } else {
              xresearcher_expertise = i.researcher_expertise;
            }
          }

          if (!i.positionex) {
            xpositionex = ["-"];
          } else {
            if (i.positionex.split("|").length > 0) {
              xpositionex = i.positionex.split("|");
            } else {
              xpositionex = i.positionex;
            }
          }

          Tb1.push({
            key: idx,
            id: i.id,
            name: i.name,
            position: i.position,
            position_aca: i.position_aca,
            positionex: xpositionex,
            email: i.email,
            researcher_expertise: xresearcher_expertise,
            picname: i.picname
          });
        });

        _dataSource(Tb1);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });

    axios
      .post(xURL + "getResearch_rihesEn", {
        center: xcenter,
        order: 2
      })
      .then(result => {
        const Tb1 = [];

        const Tb3 = [],
          Tb4 = [],
          Tb5 = [],
          Tb6 = [],
          Tb7 = [],
          Tb8 = [],
          Tb9 = [],
          Tb10 = [];

        let xresearcher_expertise = "",
          xpositionex = "";

        result.data.forEach((i, idx) => {
          if (!i.researcher_expertise) {
            xresearcher_expertise = ["-"];
          } else {
            if (i.researcher_expertise.split("|").length > 0) {
              xresearcher_expertise = i.researcher_expertise.split("|");
            } else {
              xresearcher_expertise = i.researcher_expertise;
            }
          }

          if (!i.positionex) {
            xpositionex = ["-"];
          } else {
            if (i.positionex.split("|").length > 0) {
              xpositionex = i.positionex.split("|");
            } else {
              xpositionex = i.positionex;
            }
          }

          if (xcenter !== "4") {
            if (idx > 0) {
              Tb1.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }
          } else {
            if (idx > 1) {
              Tb1.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }
          }

          if (xcenter == "2") {
            if (idx >= 0 && idx <= 8) {
              Tb3.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }

            if (idx > 8 && idx <= 12) {
              Tb4.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }

            if (idx > 12 && idx <= 18) {
              Tb5.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }

            if (idx > 18 && idx <= 23) {
              Tb6.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }

            if (idx > 23 && idx <= 27) {
              Tb7.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }

            if (idx > 27 && idx <= 30) {
              Tb8.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }
          } else if (xcenter == "1") {
            if (idx >= 0 && idx < 1) {
              Tb10.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }

            if (idx >= 1 && idx <= 2) {
              Tb9.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }

            if (idx >= 3 && idx <= 8) {
              Tb10.push({
                key: idx,
                id: i.id,
                name: i.name,
                position: i.position,
                position_aca: i.position_aca,
                positionex: xpositionex,
                email: i.email,
                researcher_expertise: xresearcher_expertise,
                picname: i.picname
              });
            }
          }
        });

        _dataSource2(Tb1);

        _dataSource3(Tb3);
        _dataSource4(Tb4);

        _dataSource5(Tb5);
        _dataSource6(Tb6);
        _dataSource7(Tb7);
        _dataSource8(Tb8);

        _dataSource9(Tb9);
        _dataSource10(Tb10);
      })
      .catch(function(error) {
        // handle error
        console.log("problem here", error);
      });
  };

  return (
    <React.Fragment>
      <StyledForm />

      {/* <Header_titleEn
        tname={localStorage.getItem("tname")}
        research_id={localStorage.getItem("research_id")}
      /> */}

      <Content
        className="site-layout"
        style={{ padding: "0 20px", marginTop: 64 }}
      >
        <style>
          @import
          url('https://fonts.googleapis.com/css2?family=Bai+Jamjuree:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;1,200;1,300;1,400;1,500;1,600;1,700&display=swap');
        </style>

        {xLng == "HSRC"
          ? <div
              style={{
                marginRight: "100px",
                marginTop: "-40px",
                marginBottom: "30px"
              }}
            >
              <img src={Logo} alt="logo_icon" width="250" height="100" />
            </div>
          : <div />}

        <div
          style={{ float: "right", marginRight: "50px", marginTop: "-40px" }}
        >
          <Space>
            <p
              style={{
                fontSize: "16px",
                marginBottom: "5px",
                fontFamily: "Bai Jamjuree",
                fontWeight: "600"
              }}
            >
              language :
            </p>
            <div className="img-lang">
              <img
                src={ThIcon}
                alt="th_icon"
                width="40"
                height="40"
                style={{ opacity: "0.3" }}
                onClick={() => {
                  window.open("/Research_rihes_list_th?pages=" + xLng, "_self");
                }}
              />
            </div>

            <div className="img-lang">
              <img
                className="img-lang"
                src={EnIcon}
                alt="en_icon"
                width="40"
                height="40"
                onClick={() => {
                  window.open("/Research_rihes_list_en?pages=" + xLng, "_self");
                }}
              />
            </div>
          </Space>
        </div>

        {/* <PageHeader className="site-page-header" title={xTitle} /> */}

        <Typography.Title
          level={2}
          style={{ textAlign: "center", fontFamily: "Bai Jamjuree" }}
        >
          {xTitle}
        </Typography.Title>
        <Divider />

        {xLng == "HSRC"
          ? <div>
              <Typography.Title
                level={4}
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  marginBottom: "20px",
                  fontFamily: "Bai Jamjuree"
                }}
              >
                Head of the Health Sciences Research Center (HSRC)
              </Typography.Title>

              <Row gutter={[24, 24]} justify="center">
                {dataSource5 &&
                  dataSource5[0] &&
                  <Col xs={24} sm={12} md={12} lg={12} key={dataSource5[0].id}>
                    <ResearchCard
                      item={dataSource5[0]}
                      xURL={xURL}
                      xLng={xLng}
                    />
                  </Col>}
              </Row>

              <Typography.Title
                level={4}
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  marginBottom: "20px",
                  fontFamily: "Bai Jamjuree"
                }}
              >
                Environmental and Occupational Health Sciences Research Unit:
                EOHS
              </Typography.Title>

              <Row gutter={[24, 24]}>
                {dataSource3 &&
                  dataSource3.map(item =>
                    <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                      <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                    </Col>
                  )}
              </Row>

              <Divider />

              <Typography.Title
                level={4}
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  marginBottom: "20px",
                  fontFamily: "Bai Jamjuree"
                }}
              >
                Health Behavior Research Unit : HBRU
              </Typography.Title>

              <Row gutter={[24, 24]}>
                {dataSource4 &&
                  dataSource4.map(item =>
                    <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                      <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                    </Col>
                  )}
              </Row>

              <Divider />

              <Typography.Title
                level={4}
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  marginBottom: "20px",
                  fontFamily: "Bai Jamjuree"
                }}
              >
                Infectious Diseases and Molecular Biosciences Research Unit :
                IMBio
              </Typography.Title>

              <Row gutter={[24, 24]}>
                {dataSource5 &&
                  dataSource5.map(item =>
                    <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                      <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                    </Col>
                  )}
              </Row>

              <Divider />

              <Typography.Title
                level={4}
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  marginBottom: "20px",
                  fontFamily: "Bai Jamjuree"
                }}
              >
                Non-communicable Diseases Research Unit: NCD
              </Typography.Title>

              <Row gutter={[24, 24]}>
                {dataSource6 &&
                  dataSource6.map(item =>
                    <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                      <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                    </Col>
                  )}
              </Row>

              <Divider />

              <Typography.Title
                level={4}
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  marginBottom: "20px",
                  fontFamily: "Bai Jamjuree"
                }}
              >
                Nutritional Research and Testing Unit: NUTRI
              </Typography.Title>

              <Row gutter={[24, 24]}>
                {dataSource7 &&
                  dataSource7.map(item =>
                    <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                      <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                    </Col>
                  )}
              </Row>

              <Divider />

              <Typography.Title
                level={4}
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  marginBottom: "20px",
                  fontFamily: "Bai Jamjuree"
                }}
              >
                Substance Abuse Research Unit: SAU
              </Typography.Title>

              <Row gutter={[24, 24]}>
                {dataSource8 &&
                  dataSource8.map(item =>
                    <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                      <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                    </Col>
                  )}
              </Row>
            </div>
          : <div style={{ margin: "0 20px" }}>
              {dataSource && dataSource.length === 1
                ? <div>
                    <Typography.Title
                      level={4}
                      style={{
                        textAlign: "center",
                        marginTop: "20px",
                        marginBottom: "20px",
                        fontFamily: "Bai Jamjuree"
                      }}
                    >
                      Head of the RIHES-Pro CRC (PROCRC)
                    </Typography.Title>
                    <Row gutter={[24, 24]} justify="center">
                      <Col xs={24} sm={12} md={12} lg={12}>
                        <ResearchCard
                          item={dataSource[0]}
                          xURL={xURL}
                          xLng={xLng}
                        />
                      </Col>
                    </Row>
                  </div>
                : dataSource &&
                  dataSource.map(item =>
                    <React.Fragment>
                      <Row key={item.id} gutter={[24, 24]} justify="center">
                        <Col xs={24} sm={12} md={12} lg={12}>
                          <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                        </Col>
                      </Row>
                      <br />
                    </React.Fragment>
                  )}

              <br />

              {/* ศูนย์ NINE ขอแก้ให้เหลือ 2 แถว 11/04/2025 */}
              {/* {xLng == "NINE"
                ? <Row gutter={[24, 24]}>
                    {dataSource2 &&
                      dataSource2.map(item =>
                        <Col xs={24} sm={12} md={12} lg={12} key={item.id}>
                          <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                        </Col>
                      )}
                  </Row>
                : <Row gutter={[24, 24]}>
                    {dataSource2 &&
                      dataSource2.map(item =>
                        <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                          <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                        </Col>
                      )}
                  </Row>} */}

              {xLng == "PROCRC"
                ? <div>
                    <Typography.Title
                      level={4}
                      style={{
                        textAlign: "center",
                        marginTop: "20px",
                        marginBottom: "20px",
                        fontFamily: "Bai Jamjuree"
                      }}
                    >
                      Senior Researcher
                    </Typography.Title>

                    <Row gutter={[24, 24]}>
                      {dataSource9 &&
                        dataSource9.map(item =>
                          <Col xs={24} sm={12} md={12} lg={12} key={item.id}>
                            <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                          </Col>
                        )}
                    </Row>

                    <Typography.Title
                      level={4}
                      style={{
                        textAlign: "center",
                        marginTop: "20px",
                        marginBottom: "20px",
                        fontFamily: "Bai Jamjuree"
                      }}
                    >
                      Physician
                    </Typography.Title>

                    <Row gutter={[24, 24]}>
                      {dataSource10 &&
                        dataSource10.map(item =>
                          <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                            <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                          </Col>
                        )}
                    </Row>
                  </div>
                : <Row gutter={[24, 24]}>
                    {dataSource2 &&
                      dataSource2.map(item =>
                        <Col xs={24} sm={12} md={8} lg={6} key={item.id}>
                          <ResearchCard item={item} xURL={xURL} xLng={xLng} />
                        </Col>
                      )}
                  </Row>}
            </div>}
      </Content>

      <div style={{ height: "100px" }} />
      {/* <div style={{ height: "200px" }} />

      <Footer_last /> */}
    </React.Fragment>
  );
};

export default Research_rihes_list_en;
